const baseURL = process.env.REACT_APP_BASE_URL;

export const certificateAPI = (certificateId: string): string => {
  return `${baseURL}coursesV1/certificates/${certificateId}`;
};
